import React from 'react';
import loadable from '@loadable/component';

const SpecialRestrictionsFilter = loadable(
  () =>
    import(
      /* webpackChunkName: "SpecialRestrictionsFilter.loadable" */ 'app/shared/modules/MobileSRP/Header/FilterModules/SpecialRestrictionsFilter/component'
    ),
);

class LoadableSpecialRestrictionsFilter extends React.Component {
  render() {
    return <SpecialRestrictionsFilter {...this.props} />;
  }
}

export default LoadableSpecialRestrictionsFilter;
